import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import Loader from "../components/utils/Loader";
import Error from "../components/utils/Error";
import { CommentForm } from "../components/comments/commentForm";
import { CommentsView } from "../components/comments/commentsView";
import { formatDisplayDate } from "../components/utils/fomatDate";
import { useBlogs } from "../hooks/useBlog";
import he from "he";
import { useEffect, useState } from "react";
function presentBlogHtml(raw) {
  if (!raw) return "";
  const decoded = he.decode(raw);
  return decoded.replace(
    /<p>(\s*)<(strong|b)\b[^>]*>([\s\S]*?)<\/\2>(\s*)<\/p>/gi,
    '<p class="blog-section">$1<$2>$3</$2>$4</p>'
  );
}

const IndividualBlog = () => {
  const { eachblog } = useParams();
  const { data: blog, isLoading, error, refetch } = useBlogs();
  const [blogs, setBlogs] = useState();

  function filterById(arr, targetId) {
    return arr.filter((item) => item.id == targetId);
  }

  useEffect(() => {
    if (blog?.data) {
      const result = filterById(blog?.data, eachblog);
      setBlogs(result[0]);
    }
  }, [blog]);

  useEffect(() => {
    refetch();
  }, []);

  if (isLoading) return <Loader />;

  if (error || !blogs)
    return (
      <div className="w-full bg-surface-white py-16 md:py-24">
        <div className="mx-auto w-full max-w-7xl px-5 sm:px-6 md:px-10">
          <Error
            title="This story isn’t loading"
            message={error ? error.message : undefined}
            onRetry={refetch}
          />
        </div>
      </div>
    );

  return (
    <div className="2xl:container flex justify-center items-center px-6 md:px-[70px] md:py-[96px] py-[48px] w-full blogasset relative">
      <div className="flex flex-col text-left w-full gap-12 md:gap-[72px] lg:gap-[96px]">
        <div className="flex flex-col gap-6 md:gap-8 lg:gap-10 md:w-[65%]">
          <div className="flex flex-col gap-2 md:gap-4 lg:gap-6">
            <h1 className="text-20 md:text-32 lg:text-48 text-headingtext md:text-32 text-20 font-[800] font-headline">
              {`“${blogs?.blog_title}”`}
            </h1>
            {/* <p className="text-14 md:text-16 text-paratext">
              {blogs?.description}
            </p> */}
          </div>
          <div className="text-14 font-[500] md:text-16 flex gap-4 md:gap-4 sm:gap-2">
            <p>{formatDisplayDate(blogs?.created_at)}</p>
          </div>
        </div>
        <div className="w-full border border-outline-variant p-4 md:p-6 lg:p-8 rounded-brand">
          <div className="w-full md:w-[40%]  md:float-right md:ml-8 mb-6 md:mb-8 md:max-w-[400px] lg:max-w-[400px]">
            <img
              src={blogs?.blog_image_url}
              alt="blog illustration"
              className="w-full "
            />
          </div>
          {/* {currentdata?.para?.map((data, i) => {
              let urlIndex = 0;
              return Object.keys(currentdata?.para[i]).includes("list") &&
                Object.keys(currentdata?.para[i]).includes("para") ? (
                <div className="flex flex-col md:flex-row bg-[#D6EBFA] p-3 md:p-6 gap-3 md:gap-6 w-full mb-8">
                  <div className="md:w-[40%] md:p-6 lg:p-8 bg-white flex flex-col p-3 gap-2 md:gap-4 lg:gap-6">
                    <h className="text-16 md:text-18 lg:text-20 text-headingtext font-[600]">
                      {data?.title}
                    </h>
                    <p className="text-14 md:text-16 text-paratext">
                      {data?.para}
                    </p>
                  </div>
                  <div className="md:w-[60%] flex flex-col gap-4 p-3 md:p-6 lg:p-8 bg-white">
                    <p className=" text-14 md:text-16 text-paratext font-[500]">
                      {data.list.title}
                    </p>
                    <ul className="flex flex-col gap-3 list-disc">
                      {data?.list?.list?.map((item, i) => (
                        <li className="text-14 md:text-16 text-paratext ml-3 md:ml-5">
                          {item?.value1.includes("<url>")
                            ? urltoanchor(item?.value1, item?.url, urlIndex)
                            : item?.value1}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : Object.keys(currentdata?.para[i]).includes("list") ? (
                <>
                  <div className="flex flex-col mb-6 gap-2 md:gap-4">
                    <h className="text-16 md:text-18 lg:text-20 text-headingtext font-[600]">
                      {data?.title}
                    </h>
                    <p className="text-14 md:text-16 text-paratext font-[500]">
                      {data.list.title}
                    </p>
                    <ul className="flex flex-col gap-3 list-disc">
                      {data?.list?.list?.map((item, i) => (
                        <li
                          key={i}
                          className="text-14 md:text-16 text-paratext ml-3 md:ml-5"
                        >
                          {item?.value1.includes("<url>")
                            ? urltoanchor(item?.value1, item?.url, urlIndex)
                            : item?.value1}
                        </li>
                      ))}
                    </ul>
                  </div>
                  {data?.list?.para ? (
                    <div>
                      <p className="text-14 md:text-16 text-paratext mb-8">
                        {data?.list.para.includes("<url>")
                          ? urltoanchor(
                              data?.list?.para,
                              data?.list?.url,
                              urlIndex
                            )
                          : data?.list.para}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  {data?.list?.list1 ? (
                    <ul className="flex flex-col gap-3 list-disc mb-8">
                      {data?.list?.list1?.map((item, i) => (
                        <li className="text-14 md:text-16 text-paratext ml-3 md:ml-5">
                          {item?.value1.includes("<url>")
                            ? urltoanchor(item?.value1, item?.url, urlIndex)
                            : item?.value1}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <div className="flex flex-col gap-3 md:gap-6 mb-8">
                  {data?.title && <h className="text-16 md:text-18 lg:text-20 text-headingtext font-[600]">
                    {data.title}
                  </h>}
                  <p className="text-14 md:text-16 text-paratext">
                    {data?.para.includes("<url>")
                      ? urltoanchor(data?.para, data?.url, urlIndex)
                      : data.para}
                  </p>
                </div>
              );
            })} */}
          <div className="blog-content">
            {parse(presentBlogHtml(blogs?.blog_content))}
          </div>
        </div>
        {/* <div className="md:-mt-[40px]">
          <h4 className="text-24 font-[800] text-headingtext ">Add Comment</h4>
          <CommentForm blogId={eachblog} />
          <CommentsView data={blogs.comments || []} />
        </div> */}
      </div>
    </div>
  );
};

export default IndividualBlog;
